export default __webpack_public_path__ + "static/media/cronos.e2371ee6.jpg";